import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../state'
import * as rules from '../rules'

import * as components from './components'

@ngCore.Component({
  imports: [
    components.glRecordSlideout.Component,
    components.filterSlideout.Component,
    ds.button.Component,
    ds.layout.page.Component,
    ds.overlay.confirmation.Component,
    ds.overlay.slideout.Component,
    ds.table.Component,
    rules.components.ruleSlideout.Component,
  ],
  selector: 'atn-rate-gl-page',
  standalone: true,
  styleUrls: ['./page.component.scss'],
  templateUrl: './page.component.html',
})
export class AtnGeneralLedgerComponent {
  /** @see {@link state.rate.gl.EcInjector} */
  public readonly glEc = ngCore.inject(state.rate.gl.records.Collection)
  /** @see {@link state.rate.rules.EcInjector} */
  public readonly ruleEc = ngCore.inject(state.rate.gl.rules.Collection)

  /** Canonical table input for the general-ledger records list. */
  public readonly tableConfig = {
    collection: this.glEc,
    view: {
      pagination: true,
      search: true,
      selection: true,
      title: 'General Ledger',
    },
  } satisfies ds.table.ec.Config.Input<state.rate.gl.records.TypeParams>

  /**
   * Selected {@link state.rate.gl.records.Entity} for
   * {@link state.rate.gl.common.Target.Slideout}  target
   */
  public slideoutRecord =
    this.glEc.plugins.currentEntityPlugin.feature.selectors.getEntity()

  /**
   * Slideout name by name attribute of the {@link slideoutRecord} record,
   * if it exist, if not we fallback to id
   */
  public readonly slideoutNameSg = ngCore.computed(
    (
      record = this.slideoutRecord.asSignal(),
      attributes = this.glEc.plugins.attributePlugin.feature.selectors.attributes.asSignal(),
    ) => {
      // TODO: come up with a better solution
      const nameAttribute = attributes.find(attr => attr.name === 'Name')
      const value = record?.attributes?.find(
        glAtt => glAtt.id === nameAttribute?.id,
      )?.value
      if (TypeChecker.isString(value)) {
        return value
      }
      return (
        record?.id ?? 'GL Record Details' // NOTE: fail back on the id, in case name is not found. // NOTE: final fallback if gl is not found.
      )
    },
  )

  /** TODO:  */
  public readonly presentFilterSlideoutSg = ngCore.signal(false)

  /* -------------------------------------------------------------------------- */
  /*                                  Handlers                                  */
  /* -------------------------------------------------------------------------- */

  /** Removes selected gl record */
  public slideoutCloseBtnClickHandler(source: string): void {
    this.glEc.plugins.currentEntityPlugin.storage.actions.putInIdLookup
      .from(source)
      .dispatch({ value: undefined })
  }

  public changeFilterSlideoutVisibilityHandler(isVisible: boolean) {
    if (isVisible) {
      // NOTE: In case that filter slideout should be displayed, applied params
      // are set as edited params for filters, so that we can edit already
      // applied filters in slideout
      this.glEc.plugins.currentListPlugin.editedParams.actions.setFilters
        .from('GeneralLedger.Table.Filter.Button.Clicked')
        .dispatch(
          this.glEc.plugins.currentListPlugin.appliedParams.selectors.filters.asSignal(),
        )
    }
    this.presentFilterSlideoutSg.set(isVisible)
  }

  /* --------------------- Rule Delete Confirmation Dialog -------------------- */

  /**
   * Dispatches save changes action for the {@link ruleEc}
   *
   * @see {@link ec.plugins.standard.ChangePlugin.dispatchSaveChanges}
   */
  public deleteRuleConfirmHandler(): void {
    this.ruleEc.plugins.editingPlugin.feature.actions.submit
      .from('Dialog.DeleteConfirmation.Buttons.Yes.Clicked')
      .dispatch({ delete: true })
  }

  /**
   * Dispatches undo changes action for the {@link ruleEc}
   *
   * @see {@link ec.plugins.standard.ChangePlugin.dispatchUndoChanges}
   */
  public deleteRuleCancelHandler(): void {
    this.ruleEc.plugins.editingPlugin.feature.actions.discard
      .from('Dialog.DeleteConfirmation.Buttons.Cancel.Clicked')
      .dispatch({
        delete: true,
      })
  }
}
